<!--<div class="container">-->
  <!--<div class="insomnia_inner">-->

      <!--<h1 class="no-info">Info to be added soon</h1>-->

  <!--</div>-->

<!--</div>-->

<div class="container">
    <div class="insomnia_inner">
        <div class="row">

            <div class="col-md-4 col-md-push-8">
                <div class="side_title insomnia">
                    <h1>
                        Brought to you by:
                    </h1>
                </div>

                <div class="insomnia_inner_sponsors ">
                    <!--<img width="130px" src="assets/img/insomnia/msi-logo-w.png" alt="">-->
                </div>


            </div>

            <div class="col-md-8 col-md-pull-4">

                <div class="side_title insomnia">
                    <h1>
                        Game Information
                    </h1>
                </div>
                <p>
                <li>Solo play</li>
                <li>One tournament per day - 64 players maximum </li>
                <li>Maximum 16 players per each Bracket</li>
                <!--<li>Single Elimination Bracket Groups - BO1</li>-->
                <!--<li>Single Elimination Semi-finals & final - BO3</li>-->
                </p>

            </div>


        </div>

        <div class="row">

            <div class="col-md-4 col-md-push-8">

                <div class="side_title insomnia">
                    <h1>
                        Prizes:
                    </h1>
                </div>

                <p>

                <li>To be determined soon</li>

                </p>

            </div>


            <div class="col-md-8 col-md-pull-4">
                <div class="side_title insomnia">
                    <h1>
                        Timing
                    </h1>
                </div>
                <p><strong>Thursday</strong> 8:00pm, 10:00pm, Finals: 12:00am</p>
                <p><strong>Friday</strong> 12:00pm, 2:00pm, 4:00pm, 6:00pm, Finals: 8:00pm</p>
                <p><strong>Saturday</strong> 12:00pm, 2:00pm, 4:00pm, 6:00pm, Finals: 8:00pm</p>

            </div>
        </div>


        <div class="row">
            <div class="col-lg-12">
                <div class="side_title insomnia">
                    <h1>Registration & Tickets</h1>
                </div>
                <p> Tournament registration will be at the event and players are allowed to compete once per day</p>
                <p>If you wish to participate in the Fortnite tournament, you will have to purchase a one day ticket.</p>
                <a href="https://tickets.virginmegastore.me/eg/others/6227/insomnia-egypt?ref=list" target="_blank"
                   class="go_button sm orange square">
                    Buy Ticket
                </a>
                <p>We recommend you read over the terms and conditions which you can find <a href="https://www.insomniagamingegypt.com/termsandconditions/" target="_blank">here</a></p>

            </div>
        </div>


    </div>

</div>
